import { isRecord } from './decode'

export type ProblemDetails = {
  type?: string
  title?: string
  status?: number
  detail?: string
  instance?: string
  code?: string
  line?: number
  column?: number
}

export class ApiError extends Error {
  readonly status: number
  readonly body: string
  readonly problem: ProblemDetails | null

  constructor(
    status: number,
    body: string,
    problem: ProblemDetails | null = null,
  ) {
    super(problem?.detail ?? problem?.title ?? `API error ${status}: ${body}`)
    this.status = status
    this.body = body
    this.problem = problem
  }

  get code(): string | undefined {
    return this.problem?.code
  }
}

export async function ignoreAlreadyGone(
  action: () => Promise<void>,
): Promise<void> {
  try {
    await action()
  } catch (error) {
    if (!(error instanceof ApiError && error.status === 404)) {
      throw error
    }
  }
}

function stringProp(value: unknown): string | undefined {
  return typeof value === 'string' ? value : undefined
}

function numberProp(value: unknown): number | undefined {
  return typeof value === 'number' ? value : undefined
}

export function parseProblem(body: string): ProblemDetails | null {
  let parsed: unknown
  try {
    parsed = JSON.parse(body)
  } catch {
    return null
  }
  if (!isRecord(parsed)) return null
  return {
    type: stringProp(parsed.type),
    title: stringProp(parsed.title),
    status: numberProp(parsed.status),
    detail: stringProp(parsed.detail),
    instance: stringProp(parsed.instance),
    code: stringProp(parsed.code),
    line: numberProp(parsed.line),
    column: numberProp(parsed.column),
  }
}
